<template>
    <v-btn
        text
        dark
        class="btn-without-border"
        title="Odmítnout"
        @click.stop="decline"
    >
        Odmítnout
    </v-btn>
</template>

<script>
    import { captureException as SentryCaptureException } from '@sentry/browser'
    import { DECLINE_JOIN_REQUEST } from '../../store/actions/team'

    export default {
        name: 'TeamRequestControlDecline',
        props: {
            requestId: {
                type: String,
                required: true,
            },
        },
        methods: {
            async decline () {
                try {
                    this.$emit('control-action', { state: 'loading' });
                    await this.$store.dispatch('team/' + DECLINE_JOIN_REQUEST, { requestId: this.requestId });
                    this.$emit('control-action', { state: 'declined' });
                    this.$toast.success('Žádost byla zamítnuta.');
                } catch (e) {
                    this.$toast.error('Při zamítnutí žádosti došlo k chybě. Zkuste to později.');
                    this.$emit('control-action', { state: null });
                    SentryCaptureException(e);
                }
            },
        },
    }
</script>
